import React from 'react';
import { ChevronLeft, ChevronRight, MapPin, Video, Clock, Calendar as CalendarIcon } from 'lucide-react';
export function CalendarPage() {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  // Simplified static calendar for March 2026
  const dates = Array.from({
    length: 35
  }, (_, i) => i - 1); // Starts from previous month
  const events = [{
    date: 5,
    title: 'Financial Modeling Workshop',
    type: 'workshop',
    time: '1:00 PM',
    color: 'bg-catalyst-mustard'
  }, {
    date: 12,
    title: 'Founder Peer Circle',
    type: 'community',
    time: '4:00 PM',
    color: 'bg-catalyst-black'
  }, {
    date: 18,
    title: 'Investor Readiness Q&A',
    type: 'workshop',
    time: '2:00 PM',
    color: 'bg-catalyst-mustard'
  }, {
    date: 25,
    title: 'Pitch Deck Review',
    type: 'advisory',
    time: '2:00 PM',
    color: 'bg-catalyst-brown'
  }];
  const upcomingEvents = [{
    id: 1,
    date: 'Mar 18',
    title: 'Investor Readiness Q&A',
    time: '2:00 PM - 3:30 PM',
    type: 'Workshop',
    location: 'Zoom'
  }, {
    id: 2,
    date: 'Mar 25',
    title: 'Pitch Deck Review',
    time: '2:00 PM - 3:00 PM',
    type: 'Advisory',
    location: 'Zoom'
  }, {
    id: 3,
    date: 'Apr 2',
    title: 'Q2 Goal Setting',
    time: '10:00 AM - 11:30 AM',
    type: 'Workshop',
    location: 'Zoom'
  }];
  return <div className="space-y-8 animate-in fade-in duration-500" data-id="element-249">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4 border-b border-gray-200 pb-6" data-id="element-250">
        <div data-id="element-251">
          <h1 className="text-3xl font-heading font-bold text-catalyst-black tracking-tight" data-id="element-252">
            Events Calendar
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-253">
            Workshops, advisory sessions, and community events
          </p>
        </div>

        <div className="flex gap-4 items-center" data-id="element-254">
          <div className="flex items-center gap-2 text-sm" data-id="element-255">
            <span className="flex items-center gap-1" data-id="element-256">
              <div className="w-3 h-3 rounded-full bg-catalyst-mustard" data-id="element-257"></div>{' '}
              Workshops
            </span>
            <span className="flex items-center gap-1 ml-2" data-id="element-258">
              <div className="w-3 h-3 rounded-full bg-catalyst-brown" data-id="element-259"></div>{' '}
              Advisory
            </span>
            <span className="flex items-center gap-1 ml-2" data-id="element-260">
              <div className="w-3 h-3 rounded-full bg-catalyst-black" data-id="element-261"></div>{' '}
              Community
            </span>
          </div>
          <button className="bg-catalyst-black text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-catalyst-brown-dark transition-colors shadow-sm" data-id="element-262">
            Sync Calendar
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-263">
        {/* Calendar View */}
        <div className="lg:col-span-2 bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-264">
          {/* Calendar Header */}
          <div className="flex justify-between items-center p-6 border-b border-gray-100" data-id="element-265">
            <h2 className="text-xl font-bold text-catalyst-black" data-id="element-266">
              March 2026
            </h2>
            <div className="flex gap-2" data-id="element-267">
              <button className="p-2 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-268">
                <ChevronLeft size={20} className="text-gray-600" data-id="element-269" />
              </button>
              <button className="px-4 py-2 border border-gray-200 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-270">
                Today
              </button>
              <button className="p-2 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-271">
                <ChevronRight size={20} className="text-gray-600" data-id="element-272" />
              </button>
            </div>
          </div>

          {/* Calendar Grid */}
          <div className="p-6" data-id="element-273">
            <div className="grid grid-cols-7 gap-px mb-2" data-id="element-274">
              {days.map(day => <div key={day} className="text-center text-xs font-bold text-gray-400 uppercase tracking-wider py-2" data-id="element-275">
                  {day}
                </div>)}
            </div>

            <div className="grid grid-cols-7 gap-2" data-id="element-276">
              {dates.map((date, idx) => {
              const isCurrentMonth = date > 0 && date <= 31;
              const displayDate = date > 0 ? date <= 31 ? date : date - 31 : 28 + date;
              const isToday = date === 20; // Mock today
              const dayEvents = events.filter(e => e.date === date);
              return <div key={idx} className={`min-h-[100px] rounded-xl p-2 border transition-all ${isCurrentMonth ? 'bg-white border-gray-100 hover:border-catalyst-mustard/30' : 'bg-gray-50 border-transparent text-gray-400'} ${isToday ? 'ring-2 ring-catalyst-mustard border-transparent' : ''}`} data-id="element-277">
                    <div className="flex justify-between items-start mb-2" data-id="element-278">
                      <span className={`text-sm font-semibold w-7 h-7 flex items-center justify-center rounded-full ${isToday ? 'bg-catalyst-mustard text-catalyst-black' : isCurrentMonth ? 'text-gray-700' : 'text-gray-400'}`} data-id="element-279">
                        {displayDate}
                      </span>
                    </div>

                    <div className="space-y-1" data-id="element-280">
                      {dayEvents.map((event, i) => <div key={i} className={`${event.color} text-white text-[10px] font-medium px-2 py-1 rounded truncate cursor-pointer hover:opacity-90 transition-opacity shadow-sm`} title={event.title} data-id="element-281">
                          {event.time} - {event.title}
                        </div>)}
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>

        {/* Upcoming Events Sidebar */}
        <div className="space-y-6" data-id="element-282">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6" data-id="element-283">
            <h2 className="text-lg font-bold text-catalyst-black mb-4" data-id="element-284">
              Upcoming Events
            </h2>

            <div className="space-y-4" data-id="element-285">
              {upcomingEvents.map(event => <div key={event.id} className="flex gap-4 group cursor-pointer" data-id="element-286">
                  <div className="flex flex-col items-center shrink-0 w-12 pt-1" data-id="element-287">
                    <span className="text-xs font-bold text-catalyst-mustard-dark uppercase" data-id="element-288">
                      {event.date.split(' ')[0]}
                    </span>
                    <span className="text-xl font-bold text-catalyst-black" data-id="element-289">
                      {event.date.split(' ')[1]}
                    </span>
                  </div>

                  <div className="flex-1 bg-gray-50 rounded-xl p-4 border border-gray-100 group-hover:border-catalyst-mustard/50 group-hover:bg-white transition-all shadow-sm" data-id="element-290">
                    <div className="flex justify-between items-start mb-1" data-id="element-291">
                      <span className="text-[10px] font-bold uppercase tracking-wider text-gray-500 bg-gray-200 px-2 py-0.5 rounded" data-id="element-292">
                        {event.type}
                      </span>
                    </div>
                    <h3 className="font-bold text-catalyst-black mb-2 group-hover:text-catalyst-mustard-dark transition-colors" data-id="element-293">
                      {event.title}
                    </h3>
                    <div className="space-y-1" data-id="element-294">
                      <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-295">
                        <Clock size={12} data-id="element-296" />
                        {event.time}
                      </div>
                      <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-297">
                        <Video size={12} data-id="element-298" />
                        {event.location}
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>

            <button className="w-full mt-6 py-2 text-sm font-medium text-catalyst-mustard-dark hover:text-catalyst-mustard transition-colors border border-gray-200 rounded-lg hover:bg-gray-50" data-id="element-299">
              View All Events
            </button>
          </div>
        </div>
      </div>
    </div>;
}